<!-- nls-rework\src\app\components\loan\auto-pay-status\auto-pay-status.component.html -->
<div class="auto-pay-section">
  @if (loan()) {
    <p class="auto-pay-status">
      Auto Pay: {{ loan()!.paymentSettings.recurringPaymentExists ? 'ON' : 'OFF' }}
      <span class="auto-pay-actions">
        @if (loan()!.paymentSettings.recurringPaymentExists) {
          <!-- Edit & Cancel buttons removed -->
        } @else {
          | <button 
              mat-button 
              color="primary" 
              class="setup-auto-pay" 
              (click)="onSetupAutoPay()">
              SET UP AUTO PAY
            </button>
        }
      </span>
    </p>
  }
</div>
